import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import BackButton from "@/components/BackButton";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#0A0605] text-white">
      <header className="max-w-3xl mx-auto flex items-center justify-between px-6 py-6">
        <Link to="/"><Logo size="md"/></Link>
        <BackButton fallback="/" label="Back"/>
      </header>
      <main className="max-w-3xl mx-auto px-6 pb-20 space-y-5 text-sm text-zinc-300 leading-relaxed">
        <h1 className="font-display text-3xl font-bold text-white">Privacy Policy</h1>
        <p className="text-xs text-zinc-500">Effective February 2026</p>
        <Section title="What we collect">
          <p>Name, email, phone, city, age band, uploaded performances, images, and how you use NextScene (feed views, likes, saves). For users under 13, we additionally collect a parent/guardian name and consent record.</p>
        </Section>
        <Section title="How we use it">
          <p>To power your profile, rank the discovery feed, deliver casting opportunities, prevent abuse, and comply with Indian digital safety guidelines for entertainment platforms.</p>
        </Section>
        <Section title="Sharing">
          <p>We share your public profile with casting agencies who explicitly search or filter for your category. We never sell your data. We share aggregated, anonymised analytics with our advertising partners.</p>
        </Section>
        <Section title="Your controls">
          <p>You can edit or delete your profile at any time from Settings → Delete Account. Support requests go to <span className="text-white">support@nextscene.in</span>.</p>
        </Section>
        <p className="text-xs text-zinc-500 pt-6 border-t border-zinc-900">This is a summary. Full policy on request.</p>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="rounded-2xl border border-zinc-800 bg-[#180D0D] p-4">
      <h2 className="font-display text-lg font-semibold text-white mb-2">{title}</h2>
      {children}
    </div>
  );
}
